import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import type { QuotationSampleSyncPreview } from '../../../api/strapiCrm';

type Props = {
  open: boolean;
  preview: QuotationSampleSyncPreview | null;
  submitting?: boolean;
  error?: string | null;
  onConfirm: () => void;
};

export function SurveyQuotationSampleSyncDialog({
  open,
  preview,
  submitting = false,
  error = null,
  onConfirm,
}: Props) {
  const items = preview?.items ?? [];

  return (
    <Dialog
      open={open}
      onClose={() => undefined}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      data-testid="survey-quotation-sample-sync-dialog"
    >
      <DialogTitle>Sample quotation bertambah</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ pt: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            Ada perubahan sample di quotation yang belum masuk daftar berita acara. Sinkronisasi wajib
            agar titik baru muncul di grid sampling.
          </Typography>
          {preview ? (
            <Typography variant="body2">
              {preview.new_sample_count > 0
                ? `${preview.new_sample_count} sample baru`
                : null}
              {preview.new_sample_count > 0 && preview.extended_plan_count > 0 ? ' · ' : null}
              {preview.extended_plan_count > 0
                ? `${preview.extended_plan_count} rencana dengan titik tambahan`
                : null}
              {preview.added_point_total > 0
                ? ` (total +${preview.added_point_total} titik)`
                : null}
            </Typography>
          ) : null}
          {items.length > 0 ? (
            <Stack component="ul" spacing={0.5} sx={{ m: 0, pl: 2.5 }}>
              {items.map((item) => (
                <Typography
                  key={`${item.kind}:${item.quotation_sample_information_document_id}`}
                  component="li"
                  variant="body2"
                >
                  {item.kind === 'new_sample'
                    ? `${item.bidang_pengujian_label} — sample baru (${item.point_count} titik)`
                    : `${item.bidang_pengujian_label} — titik ${item.previous_point_count} → ${item.point_count} (+${item.added_point_count})`}
                </Typography>
              ))}
            </Stack>
          ) : null}
          {error ? (
            <Alert severity="error" data-testid="survey-quotation-sample-sync-error">
              {error}
            </Alert>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={submitting || !preview?.has_pending}
          data-testid="survey-quotation-sample-sync-confirm"
        >
          {submitting ? 'Menyinkronkan…' : 'Sinkronkan'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
